import type { ColumnsType } from "antd/es/table";
import { DataTable } from "@/shared/components/DataTable";
import { usePaginatedQuery } from "@/shared/hooks/usePaginatedQuery";

export interface EmployeeListTabProps<T extends object> {
	employeeId: string;
	/** Kesh kaliti — `employeeId` shu yerda EMAS, karkas o'zi qo'shadi. */
	queryKey: unknown[];
	url: string;
	columns: ColumnsType<T>;
	onRowClick?: (row: T) => void;
}

/**
 * Profil yorliqlarining umumiy karkasi: mavjud endpointning `employeeId`
 * bilan filtrlangan ko'rinishi.
 *
 * ⚠️ **`DataTable` va `usePaginatedQuery` QAYTA ISHLATILADI** — yangi
 * jadval komponenti yozilmaydi.
 *
 * ⚠️ **Sahifalash holati HAR yorliqda O'ZINIKI** — `usePaginatedQuery`
 * uni o'z ichida saqlaydi va karkas har yorliq uchun alohida
 * chaqiriladi; `destroyOnHidden` (`EmployeeDetailPage`) yorliq
 * yopilganda uni tozalaydi.
 *
 * ⚠️ **Qator bosilishi — ichkariga kirish**, oxirgi nuqta emas: profil
 * zanjirning o'rtasi. `onRowClick` berilmagan yorliqda kursor ham
 * o'zgarmaydi, aks holda bosiladigan taassurot yolg'on bo'lardi.
 */
export function EmployeeListTab<T extends object>({
	employeeId,
	queryKey,
	url,
	columns,
	onRowClick,
}: EmployeeListTabProps<T>) {
	const query = usePaginatedQuery<T>({
		queryKey: [...queryKey, employeeId],
		url,
		params: { employeeId },
	});

	return (
		<DataTable<T>
			columns={columns}
			query={query}
			onRow={
				onRowClick
					? (row: T) => ({ onClick: () => onRowClick(row), style: { cursor: "pointer" } })
					: undefined
			}
		/>
	);
}
